module.exports = __webpack_public_path__ + "static/media/3_1park.1ad25fe8.png";